/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 *
 * @export
 * @interface DeploymentStatusCount
 */
export interface DeploymentStatusCount {
  /**
   *
   * @type {number}
   * @memberof DeploymentStatusCount
   */
  live: number;
  /**
   *
   * @type {number}
   * @memberof DeploymentStatusCount
   */
  inReview: number;
  /**
   *
   * @type {number}
   * @memberof DeploymentStatusCount
   */
  notLive: number;
}

/**
 * Check if a given object implements the DeploymentStatusCount interface.
 */
export function instanceOfDeploymentStatusCount(value: object): value is DeploymentStatusCount {
  if (!('live' in value) || value['live'] === undefined) return false;
  if (!('inReview' in value) || value['inReview'] === undefined) return false;
  if (!('notLive' in value) || value['notLive'] === undefined) return false;
  return true;
}

export function DeploymentStatusCountFromJSON(json: any): DeploymentStatusCount {
  return DeploymentStatusCountFromJSONTyped(json, false);
}

export function DeploymentStatusCountFromJSONTyped(json: any, ignoreDiscriminator: boolean): DeploymentStatusCount {
  if (json == null) {
    return json;
  }
  return {
    live: json['live'],
    inReview: json['in review'],
    notLive: json['not live'],
  };
}

export function DeploymentStatusCountToJSON(value?: DeploymentStatusCount | null): any {
  if (value == null) {
    return value;
  }
  return {
    live: value['live'],
    'in review': value['inReview'],
    'not live': value['notLive'],
  };
}
